import React from 'react';
import Link from 'next/link';
import TextField from '../form/text-field';
import { Button } from 'rmwc/Button';
import gtagEvent from '../../utilities/analytics/gtag-event';

import './landing-pages.css';
import '@material/button/dist/mdc.button.min.css';

const heroUri = 'https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2Fsign-up.JPG?alt=media&token=ea46f6d1-d591-4fff-a172-752052b8e489';

export default props => {
  return (
    <article id="get-our-free-newsletter" className="static-landing-page" role="main">
      <section className="centered">
        <div className="row">
          <div className="hide-small">
            <img className="hero" src={heroUri} alt="Melissa Esplin headshot" />
          </div>
          <div className="flex">
            <h1 className="headline-text">No spam. Just Calligraphy.</h1>
            <p className="primary-text">

              We'll send you email with everything you need to get started.
            </p>
            <form
              action="https://app.mailerlite.com/webforms/submit/e7m9b7"
              method="post"
            >
              <div style={{ display: 'none' }}>
                <input
                  type="text"
                  name="ml_message"
                  tabIndex="-1"
                  defaultValue=""
                  placeholder="Message"
                  autoComplete="off"
                  title="message"
                />
                <input
                  type="text"
                  name="ml_email"
                  tabIndex="-1"
                  defaultValue=""
                  placeholder="Email"
                  autoComplete="off"
                  title="email"
                />
                <input
                  type="text"
                  name="ml_name"
                  tabIndex="-1"
                  defaultValue=""
                  placeholder="Name"
                  autoComplete="off"
                  title="name"
                />
              </div>

              <input type="hidden" name="ml-submit" value="1" />

              <TextField type="email" data-inputmask="" name="fields[email]" placeholder="email" />
              <Button
                type="submit"
                className="cta-button"
                raised
                onClick={() =>
                  gtagEvent('cta-click', { page: 'get-our-free-newsletter', position: 'primary' })
                }
              >
                Get Started Now
              </Button>
            </form>
          </div>
        </div>
      </section>
    </article>
  );
};
